import { NAV_BAR_CONTEXT } from '$global/features/navigation/constants/nav-bar-context';

export enum Contexts {
	NftQueries = 'nftQueries',
	OrderConfirmation = 'orderConfirmation',
	Invoice = 'invoice',
	Now = 'now',
	RegisterInterest = 'registerInterest',
	RegisterInterestNotes = 'registerInterestNotes',
	Checkout = 'checkout',
	ShowCartCheckout = 'showCartCheckout',
	Web3 = 'web3',
	GenericApplication = 'generic-application',
	NavBar = `${NAV_BAR_CONTEXT}`,
	VaultWithdrawal = 'vault-withdrawal',
	VaultWithdrawalOutstanding = 'vault-withdrawal-outstanding',
	Auth = 'auth',
	AuthForms = 'auth-forms',
	FaqSearch = 'faq-search',
	LiveDropInfo = 'live-drop-info',
	PrimaryArtworksPreferences = 'primary-artworks-preferences',
	Wishlist = 'wishlist',
}
